export {
  accountDetailDataActions,
  accountDetailDownloadActions,
  accountListDataActions,
  accountsBankingProductLoanReceiptsFiltersActions,
  accountsBankingProductMovementsFiltersActions,
  accountsInvestmentsFiltersActions,
  accountsOperationsFiltersActions,
  awmFundsDataActions,
  awmFundsDownloadActions,
  bankingProductLoanReceiptsDownloadActions,
  bankingProductMovementsDownloadActions,
  bankingProductsDataActions,
  cashMovementDetailDataActions,
  editAliasDataActions,
  productOperationDetailDataActions,
  productOperationsMasterListDownloadActions,
  productOperationsMasterListActions as productOperationsMasterListSliceActions,
  productsByTypeDataActions,
} from '../slices'
import { createAction } from '@reduxjs/toolkit'
import {
  BankingProductMovementsParams,
  EditAliasPayload,
  ProductOperationParams,
  ProductReceiptParams,
} from '@repo/accounts-types'
import { CopyToClipboardPayload } from '@repo/core'
import { BankingProductType } from '@repo/shared-types'
import {
  bankingProductLoanReceiptsDataActions as bankingProductLoanReceiptsDataSliceActions,
  bankingProductMovementsDataActions as bankingProductMovementsSliceActions,
  productOperationsMasterListActions as productOperationsMasterListSliceActions,
} from '../slices'

export const individualPortfolioDataActions = {
  getAccountDetail: createAction<{ accountId: string }>('@accounts/individualPortfolio/getRequest'),
}

export const aliasActions = {
  saveEditAlias: createAction<EditAliasPayload>('@accounts/alias/saveEditAlias'),
}

export const bankingProductsActions = {
  getBankingProducts: createAction<{ productType: BankingProductType; isRefreshing?: boolean }>(
    '@accounts/bankingProducts/getRequest',
  ),
}

export const productOperationsMasterListActions = {
  ...productOperationsMasterListSliceActions,
  getRequestByFilters: createAction<ProductOperationParams>(
    '@accounts/master/list/operations/getRequestByFilters',
  ),
}

export const copyToClipboardActions = {
  copy: createAction<CopyToClipboardPayload>('@accounts/clipboard/copy'),
}

export const bankingProductMovementsDataActions = {
  ...bankingProductMovementsSliceActions,
  getRequestByFilters: createAction<BankingProductMovementsParams>(
    '@accounts/master/list/bankingProductMovements/getRequestByFilters',
  ),
}
export const bankingProductLoanReceiptsDataActions = {
  ...bankingProductLoanReceiptsDataSliceActions,
  getRequestByFilters: createAction<ProductReceiptParams>(
    '@accounts/master/list/bankingProductLoanReceipts/getRequestByFilters',
  ),
}
